export const SSO_COOKIE_NAME = 'dm_sso';
export const POLL_INTERVAL: number = 5000;

export enum TeacherFiltersEnum {
  VISIBILITY = 'TEACHER_VISIBILITY',
  PROGRESS = 'TEACHER_PROGRESS',
  SCORES = 'TEACHER_SCORES',
  FOLLOW_UP = 'FOLLOW_UP',
  KNOWLEDGE_BASE = 'TEACHER_KNOWLEDGE_BASE',
}

export enum StudentFiltersEnum {
  PROGRESS = 'STUDENT_PROGRESS',
  SCORES = 'STUDENT_SCORES',
  PROGRESS_AND_SCORES = 'STUDENT_PROGRESS_AND_SCORES',
}

export enum BookmarkModeEnum {
  DISABLED = 'disabled',
  SELECT_BLOCK = 'selectBlock',
  TEACHER_OPTIONS = 'teacherOptions',
}

export enum NotesModeEnum {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
}

export const showHelpModals: boolean = false;
